module.exports = __webpack_public_path__ + "img/banners_criancas_406x406.93b90096.jpg";